module.exports = __webpack_public_path__ + "static/media/shopify-icon.47825b99.svg";